import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { AccessibilityClickableDiv } from '@skillz/accessibility';
import Icon from '../../ui/icons/Icon';
import iconsList from '../../ui/icons/iconsList';
import useClickOutside from '../../../hooks/useClickOutside';
import classes from './DropDown.module.css';

const DropDown = ({ children, options, expanded, dropClass, arrowColor, value, showValue = true, closeOnApply = false, dropClassDropDown, optionClassName, hideSelectedInList = false }) => {
  const [showDropDown, setShowDropDown] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);

  const selectRef = useRef();

  useClickOutside(selectRef, () => setShowDropDown(false));

  useEffect(() => {
    showValue && setSelectedValue(value)
  }, [value, showValue])

  const handleSelect = (option) => {
    option.onClick();
    showValue && setSelectedValue(option.value);
    !closeOnApply && setShowDropDown(false);
  };
  const displayedOptions = (hideSelectedInList && selectedValue) ? options.filter((o) => o.value !== selectedValue) : options;

  return (
    <div className={`${classes.Select} ${dropClass} ${showDropDown ? classes.Open : ''}`} ref={selectRef}>
      <AccessibilityClickableDiv className={classes.Value} onClick={() => setShowDropDown(prev => !prev)}>
        <div className={classes.ValueText}>
          {selectedValue || children}
        </div>
        <div className={`${classes.Arrow} ${showDropDown ? classes.ArrowOpen : ''}`}>
          <Icon name={iconsList.down} color={arrowColor || `#fff`} size={16} />
        </div>
      </AccessibilityClickableDiv>

      {(showDropDown || expanded) &&
        <div className={`${classes.DropDown} ${dropClassDropDown}`}>
          {displayedOptions?.map((option) => (
            <AccessibilityClickableDiv key={option.key} className={`${classes.Option} ${optionClassName || ''}`} onClick={() => handleSelect(option)}>
              {option.value}
            </AccessibilityClickableDiv>
          ))}
        </div>
      }
    </div>
  );
};

export default DropDown;